import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import { Constants } from 'src/constants/constants';
import { AppColors } from 'src/themes/Colors';
import styled from 'styled-components/native';
import { RegularText } from '../bases';

const Styled = {
  Wrapper: styled(TouchableOpacity)`
    height: 26px;
    justify-content: center;
  `,
};

interface Props extends TouchableOpacityProps {
  disabled?: boolean;
  text: string;
  color?: string;
  size?: 'huge' | 'large' | 'regular' | 'medium' | 'small' | number;
  fontWeight?: 'normal' | 'bold' | '100' | '200' | '300' | '400' | '500' | '600' | '700' | '800' | '900';
}

export const TextButton = ({
  disabled = false,
  size,
  text,
  color = AppColors.primary,
  style = {},
  onPress,
  fontWeight,
}: Props) => {
  return (
    <Styled.Wrapper disabled={disabled} style={style} activeOpacity={Constants.ACTIVE_OPACITY} onPress={onPress}>
      <RegularText fontWeight={fontWeight} fontSize={size} color={color} textLang={text} />
    </Styled.Wrapper>
  );
};
